import { flattenDepth } from 'lodash-es';

function convertDatesToTimestamps(dates) {
  return dates.map((date) => new Date(date).getTime());
}

export default (reportData) => {
  if (!Array.isArray(reportData)) {
    return [];
  }

  return flattenDepth(
    reportData.map((item) =>
      item.periods.map((period) => ({
        x: item.name,
        y: convertDatesToTimestamps(period),
      }))
    ),
    2
  );
};
